import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {
  BORDER,
  COLOR_GREY_12,
  COLOR_GREY_2,
  COLOR_GREY_3,
  COLOR_GREY_5,
  COLOR_WHITE,
} from "shared/theme/colors";
import FlexColumn from "../Layout/components/FlexColumn";

export const StyledButton = styled(Button, {
  shouldForwardProp: (propName) =>
    !["isSmallButton", "isActive"].includes(propName),
})<{
  isActive: boolean;
  isSmallButton: boolean;
}>`
  border-radius: 0.5rem;
  font-weight: ${({ isSmallButton }) => (isSmallButton ? 400 : 500)};
  font-size: 0.875rem;
  text-transform: initial;
  padding: ${({ isSmallButton }) =>
    isSmallButton ? "4px 8px" : "0.5rem 1rem"};
  box-sizing: border-box;
  border: ${({ isSmallButton, isActive }) =>
    isSmallButton
      ? BORDER(1, isActive ? COLOR_GREY_12 : COLOR_GREY_5)
      : "none"};

  background-color: ${({ isActive }) =>
    isActive ? COLOR_GREY_3 : COLOR_WHITE};

  &.MuiButton-root {
    &:hover {
      background-color: ${COLOR_GREY_2};
    }

    & .MuiButton-endIcon {
      margin-left: ${({ isSmallButton }) => (isSmallButton ? "4px" : "8px")};
    }

    &:disabled {
      span {
        color: ${COLOR_GREY_5};
      }

      svg > path {
        fill: ${COLOR_GREY_5};
      }
    }
  }
`;

export const StyledMenu = styled(Menu)`
  border-radius: 0.75rem;
  top: 0.5rem;
  left: 0;

  .MuiList-root {
    padding-bottom: 0;
  }

  .MuiPaper-root {
    background-color: ${COLOR_WHITE};
    border-radius: 12px;

    &.MuiMenuItem-root:hover {
      background-color: ${COLOR_GREY_2};
    }

    &.MuiMenuItem-root {
      height: 2.5rem;
      font-weight: 500;
      font-size: 0.875rem;
    }
  }
`;

export const StyledTypography = styled(Typography)`
  font-weight: 500;
  font-size: 0.875rem;
`;

export const StyledMenuItem = styled(MenuItem)`
  display: flex;
  column-gap: 0.5rem;
  padding-right: 2rem;
`;

export const StyledFooterWrapper = styled(FlexColumn)`
  padding-bottom: 0.5rem;
  position: sticky;
  bottom: 0;
  background-color: ${COLOR_WHITE};
  width: 100%;

  .clear-filter {
    padding-left: 1rem;
    align-self: flex-start;
    column-gap: 0.75rem;
  }

  &::before {
    content: "";
    width: 100%;
    height: 1px;
    background-color: ${COLOR_GREY_3};
    margin-bottom: 0.5rem;
  }

  &:hover {
    background-color: ${COLOR_GREY_2};
  }
`;
